var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5053",
    "data-name": "Groupe 5053",
    transform: "translate(-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AVATAR_COLONNE_GAUCHE",
    "data-name": "AVATAR COLONNE GAUCHE",
    transform: "translate(5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 57.5,
    cy: 57.5,
    r: 57.5,
    fill: "#4493a3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer13",
    transform: "translate(30.82 17.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path870",
    d: "M2.117,2.118V61.242a10.93,10.93,0,0,0,1.119,4.514,8.787,8.787,0,0,0,8.116,4.72H52a10.967,10.967,0,0,0,4.529-1.119,8.778,8.778,0,0,0,4.706-8.116V9.508H59.393L11.355,9.5Z",
    transform: "translate(0 7.925)",
    fill: "#e4bc6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path868",
    d: "M11.351.793A10.972,10.972,0,0,0,6.822,1.912a8.8,8.8,0,0,0-4.706,8.13,8.778,8.778,0,0,0,4.706,8.116,10.974,10.974,0,0,0,4.529,1.119H59.389c2.884-.588,2.021-3.7,0-3.7a7.38,7.38,0,0,1-2.865-.722c-1.407-.7-2.674-1.735-2.674-4.814s1.267-4.11,2.674-4.814a7.553,7.553,0,0,1,2.865-.736,1.812,1.812,0,0,0,1.851-1.848A1.81,1.81,0,0,0,59.393.8Z",
    transform: "translate(0)",
    fill: "#e9ebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path876",
    d: "M5.023,1.852a1.848,1.848,0,1,0,0,3.7H38.274a1.848,1.848,0,0,0,0-3.7Z",
    transform: "translate(6.329 6.335)",
    fill: "#d9dbdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path885",
    d: "M15.052,4.5a3.725,3.725,0,0,0-3.71,3.71V24.836H7.654a3.7,3.7,0,0,0-2.62,6.3L17.968,44.07a3.72,3.72,0,0,0,5.229,0L36.13,31.136a3.695,3.695,0,0,0-2.613-6.3h-3.7V8.207a3.725,3.725,0,0,0-3.71-3.71Z",
    transform: "translate(11.091 22.163)",
    fill: "#e0b35c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path878",
    d: "M13.471,4.762a1.848,1.848,0,0,0-1.855,1.855V25.1H6.081a1.848,1.848,0,0,0-1.31,3.15L17.7,41.18a1.848,1.848,0,0,0,2.616,0l12.93-12.93A1.848,1.848,0,0,0,31.94,25.1H26.4V6.617a1.848,1.848,0,0,0-1.855-1.855Z",
    transform: "translate(12.665 23.746)",
    fill: "#e9ebef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBook);
export default __webpack_public_path__ + "static/media/download_book.8a43ec5c.svg";
export { ForwardRef as ReactComponent };